const CLICKUP_API_KEY = process['env'].CLICKUP_API_KEY;
const CLICKUP_URL = process['env'].CLICKUP_URL || 'https://private-anon-628a449fc7-clickup20.apiary-proxy.com';

export const createClickUpTask = async (task_name, task_description, list_id, reportedBy) => {
  task_description = `Reported by: ${reportedBy}\n${task_description}`;
  const res = await fetch(`${CLICKUP_URL}/api/v2/list/${list_id}/task`, {
    method: 'POST',
    headers: {
      Authorization: CLICKUP_API_KEY,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name: task_name,
      description: task_description,
      tags: ['from hub'],
      status: 'Open',
      notify_all: true,
    }),
  });
  const json = await res.json();
  if (res.ok) {
    return json;
  }
  throw new Error(json.err);
};
